import { type Message, UserDocumentTypeItem } from 'schema'

export type TUserResponse<T> = NonNullable<{
  data?: T
  message?: Array<Message>
}>

export type TUserDocumentType = UserDocumentTypeItem

export enum UserDocumentTypeEnum {
  DriverLicense = 'driverLicense',
  PassportInternational = 'passportInternational',
  PassportRF = 'passportRF'
}

export type TFieldErrors = {
  path: string
  title: string
}
